import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../buttons/customButton';
import CopyIcon from '../../assets/icons/copyIcon.svg';
import closableEnqueueSnackbar from '../closableEnqueueSnackbar/closableEnqueueSnackbar';

interface CopyUrlLinkInterface {
  digcode: string,
  closeDialog: () => void,
}

const CopyUrlLink: React.FC<CopyUrlLinkInterface> = (props) => {
  const { t } = useTranslation();
  const [url, setUrl] = useState('');
  const [generatedUrl, setGeneratedUrl] = useState('');
  const DIG_CODE = props.digcode;

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputUrl = e.target.value;

    if (!inputUrl.startsWith('https://')) {
      inputUrl = `https://${inputUrl}`;
    }

    setUrl(inputUrl);
    setGeneratedUrl(inputUrl);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(`${generatedUrl}?dig=${DIG_CODE}`).then(() => {
      closableEnqueueSnackbar((t('URLcopiedToclipboard')), 'success');
    });
  };

  return (
    <div className="flex w-full flex-col items-center gap-4">
      <div className="flex h-[48px] w-full max-w-[490px] items-center rounded-[8px] border border-[#BDBDBD] ">
        <span className="flex h-full w-[82px] items-center justify-center rounded-l-[8px] bg-[#EAEAEA] font-normal text-primary">https://</span>
        <input
          type="text"
          placeholder="Paste or enter the rest of the URL here"
          value={url.replace('https://', '')}
          onChange={handleUrlChange}
          className="grow p-2 text-primary outline-none"
        />
      </div>

      <div className="flex h-full w-full max-w-[490px] gap-2">
        <div className="flex h-[48px] w-full max-w-[440px] items-center gap-2 rounded-[8px] border border-[#BDBDBD] bg-[#EAEAEA] p-2">
          <div>
            <span className="truncate pl-2 text-primary">
              {generatedUrl.length > 20 ? '...' : ''}
              {generatedUrl.replace('https://', '').slice(generatedUrl.length - 30, generatedUrl.length + 1).split('?')[0]}
            </span>
            <span className="text-[#4C956C]">
              {
              generatedUrl.length > 8
                ? url.includes('?')
                  ? `&dig=${DIG_CODE}`
                  : `?dig=${DIG_CODE}`
                : ''
              }
            </span>
          </div>
        </div>
        <button onClick={handleCopy} className="flex h-[48px] w-[48px] items-center justify-center rounded border border-[#EAEAEA] p-2">
          <img src={CopyIcon} alt="" />
        </button>
      </div>
      <div className="mt-4 flex h-full w-full justify-end py-2">
        <CustomButton onClick={() => props.closeDialog()} className="h-[41px]" color="primary">
          {t('done')}
        </CustomButton>
      </div>
    </div>
  );
};

export default CopyUrlLink;
